import { StringEncodings } from "./image-draw.model"

export const generateBuildingOptions = (stringEncodings: StringEncodings) => {
  return stringEncodings.buildings.map((building, idx) => ({label: building, value: idx+1}))
}

export const generateRoadOptions = (stringEncodings: StringEncodings) => {
  return stringEncodings.roads.map((road, idx) => ({label: road, value: idx+1}))
}

